import { type NotificaUtenteResponseDTO } from '@framework/api-client/api/inquiries-compile/schemas/notificaUtenteResponseDTO.ts';
import { Drawer } from '@framework/ui/components/drawer/Drawer.tsx';
import { PaginationSimple } from '@framework/ui/components/pagination/PaginationSimple.tsx';
import { Space } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { ButtonNotificationReadAll } from './detail/ButtonNotificationReadAll.tsx';
import { NotificationFilterSwitch } from './detail/NotificationFilterSwitch.tsx';
import { NotificationList } from './NotificationList.tsx';
import { checkNotificationsToRead } from './utils/checkNotificationsToRead.ts';

const NotificationsDrawerBase = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 600px !important;
    max-width: 70%;
    ${down('sm')} {
      width: 100% !important;
      max-width: 100%;
    }
  }

  .ant-drawer-header {
    padding: 10px;
  }
  .ant-drawer-body {
    padding: 0;
  }
  .ant-drawer-title {
    line-height: 1.3;
  }
`;

export interface INotificationsDrawerProps {
  handleClose: () => void;
  visible: boolean;
  filterToRead?: boolean;
  setFilterToRead: (value: boolean | undefined) => void;
  setPage: (page: number) => void;
  total: number;
  page: number;
  pageSize: number;
  notifications: NotificaUtenteResponseDTO[] | null | undefined;
  apiResult: any;
  id?: string;
  showNotificationsPage?: boolean;
}

/**
 * Drawer delle notifiche
 */
export function NotificationsDrawer(props: INotificationsDrawerProps) {
  const {
    handleClose,
    visible,
    filterToRead,
    setFilterToRead,
    setPage,
    notifications,
    apiResult,
    total,
    page,
    pageSize,
    id,
    showNotificationsPage,
  } = props;

  const { t } = useTranslation();

  const hasNotificationsToRead = useMemo(() => {
    return checkNotificationsToRead(notifications);
  }, [notifications]);

  return (
    <NotificationsDrawerBase
      id={id}
      title={
        <Space>
          {t('notification-drawer.title', 'Notifiche')}
          <ButtonNotificationReadAll
            hasNotificationsToRead={hasNotificationsToRead}
          />
        </Space>
      }
      placement="right"
      onClose={handleClose}
      // visible={visible}
      open={visible}
      extra={
        <Space>
          {!showNotificationsPage && (
            <NotificationFilterSwitch
              defaultChecked={filterToRead === false}
              onChange={value => {
                // Seleziona solo quelle da leggere, altrimenti tutte
                setFilterToRead(value ? false : undefined);
                setPage(1);
              }}
            />
          )}
          <PaginationSimple
            total={total}
            current={page}
            pageSize={pageSize}
            onChange={page => {
              setPage(page);
            }}
          />
        </Space>
      }
      key="notificaion-drawer"
    >
      <NotificationList list={notifications} loading={apiResult.isLoading} />
    </NotificationsDrawerBase>
  );
}
